module.exports = __webpack_public_path__ + "static/irene@small-6e96c04916930f91453783f7729c57f4.jpg";